module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_pl_polish-cd835d05865e496ff6b868655a4c8856.svg";